import { useCallback, useRef, useState } from 'react';
import cls from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import styles from './index.module.scss';

export default (props: Record<string, any>) => {
  const { hotGoods = [] } = props;
  const [videoH, setVideoH] = useState<number>(729);
  const videCurrentRef = useRef<boolean>(true);
  const bannerRef = useRef<any>();
  const videoRef = useRef<any>();
  const changeSwiper = useCallback(() => {
    videoRef?.current?.load();
    setTimeout(() => {
      console.log('videCurrentRef.current===', videCurrentRef.current);
      if (videCurrentRef.current) {
        videoRef?.current?.play();
      } else {
        videoRef?.current?.pause();
      }
    }, 100);
  }, []);
  const gotoDetail = useCallback((item: any) => {
    if (item?.redirectUrlH5) {
      window.open(item.redirectUrlH5);
    }
  }, []);
  return (
    <div className={styles['hot-container']}>
      <Swiper
        autoplay={false}
        modules={[Navigation, Scrollbar, Pagination, Autoplay]}
        className="container"
        spaceBetween={0}
        slidesPerView={1}
        navigation
        onSlideChange={changeSwiper}
        pagination={{ clickable: true }}
      >
        {(hotGoods || []).map((item: any, index: number) => {
          const type = item.url.substring(item.url.lastIndexOf('.') + 1, item.url.length);
          return (
            <SwiperSlide className="card" key={item.url}>
              {({ isActive }: { isActive: boolean }) => {
                console.log('isActive====', isActive);
                if (isActive && index === 0 && type === 'mp4') {
                  videCurrentRef.current = true;
                } else if (index === 0 && type === 'mp4' && !isActive) {
                  videCurrentRef.current = false;
                }
                return (
                  <div className={styles['hot-inner']}>
                    <img src={item.url} onClick={() => gotoDetail(item)} />
                    <div className={styles['hot-title']}>{item.title}</div>
                  </div>
                );
              }}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
